// extracted by mini-css-extract-plugin
export default {"switch":"app-organizations-OrganizationForm-OrganizationForm-module__LDab3XkRFzM8FkvhE8k4"};